module.exports = __webpack_public_path__ + "img/b.a433853a.jpg";